import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialTable from "../../Components/Table/MaterialTable";
import { FaSearch } from "react-icons/fa";
import { leftArrow } from "../../common/Assets/imgs";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

const TransactionView = () => {
  const navigation = useNavigate();
  const [popup, setPopup] = useState(false);
  const location = useLocation();
  console.log("location", location);
  const data = location?.state?.rowData;
  console.log("data", data);
  // const row= location?.state?.rowData;
  const id = location?.state?.id;
  console.log("id", id);
  const status = location?.state?.status;
  console.log("status", status);
  const createdAtFromList = location?.state?.rowData?.created_at;
  const [selectedIds, setSelectedIds] = useState([]);
  const [valuee, setValuee] = useState("")
  const [totalCount, setTotalCount] = useState(1);
  const [isLoading, setIsLoading] = useState(false);


  //  const adminList = [
  //         {
  //             sno: "01",
  //             adminId: "KD075821",
  //             adminName: "Vikram",
  //             role: "Admin",
  //             mobile: "+91 8965346856",
  //             status: "Active",
  //             DateTime:"10-12-2025,1:00 PM",
  //             amount:"3500",
  //             // payment:"Advance",
  //         },
  //         {
  //             sno: "02",
  //             adminId: "KD075822",
  //             adminName: "Surya",
  //             role: "Super Admin",
  //             mobile: "+91 8965346856",
  //             status: "Active",
  //             DateTime:"10-12-2025,1:00 PM",
  //             amount:'16500',
  //             // payment:"Full Amount",
  //         },
  //         {
  //             sno: "03",
  //             adminId: "KD075823",
  //             adminName: "Ajay",
  //             role: "Sub Admin",
  //             mobile: "+91 8965346856",
  //             status: "De-Active",
  //             DateTime:"10-12-2025,1:00 PM",
  //             amount:'6550',
  //             // payment:"Advance",
  //         },
  //     ];

  const [adminList, setAdminList] = useState([]);

  const handleSelectionChange = (rows) => {
    const ids = rows.map((row) => row.id).filter(Boolean);
    setSelectedIds(ids);
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // convert 0 → 12

    return `${day}-${month}-${year}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
  };

  useEffect(() => {
    console.log("selectedIds", selectedIds);
  }, [selectedIds]);


  const columns = [
    {
      // accessorKey: "sno",
      header: "S.No",
      accessorFn: (row, index) => index + 1,
      id: "serial_no",
    },
    {
      accessorKey: "ride_id",
      header: "Ride ID",
    },

    {
      accessorKey: "total_amount",
      header: "Amount",
      Cell: ({ cell }) => {
        return (
          <span style={{ color: "#28a745", fontWeight: 500 }}>
            {cell.getValue()}
          </span>
        );
      },
    },
    // {
      
      //  accessorKey: "date_time",
      // header: "Date & Time",
      // Cell: ({ cell }) => (
      //   <span>
      //     {formatDate(cell.getValue())}
      //   </span>
      // ),
      
    // },
    {
  accessorKey: "created_at",
  header: "Date & Time",
  Cell: ({ row }) => (
    <span>
      {formatDate(
        status === "completed"
          // ? createdAtFromList   // ✅ from previous page
         ? data?.created_at
          : row.original.date_time
      )}
    </span>
  ),
}

  ];

  // const getList = async () => {
  //   try {
  //     const res = await get(`${URLS.TRANSPORT_PENDING_VIEW}${id}/`);
  //     console.log("res", res);
  //     if (res?.status === "success") {
  //       setAdminList(res?.data);
  //     }
  //   } catch (err) {
  //     console.log("err", err);
  //   }
  // };
  const getList = async () => {
    let res;
    try {
      if (status === "pending") {
        res = await get(`${URLS.TRANSPORT_PENDING_VIEW}${id}/`);
        // console.log("res", res);
      }
      else {
        res = await get(`${URLS.TRANSPORT_COMPLETED_PAYMENT}?payment_id=${data?.transport_payment_id}`);
      }
      if (res?.status === "success") {
        setAdminList(res?.data);
        // setTotalCount(res?.count);
      }
    } catch (err) {
      console.log("err", err);
    }
  };
  useEffect(() => {
    getList();
  }, []);

  const handleSubmit = async () => {

    const trimmed = {
      transport_id: id,
      booking_detail_ids: selectedIds,
      transaction_name: valuee,
    }
    try {
      setIsLoading(true);
      const res = await post(`${URLS.TRANSPORT_PAYMENT}`, trimmed)
      console.log('res payment', res);
      if (res?.status === "success") {
        setIsLoading(false);
        setPopup(false);
        setValuee("");
        navigation(-1,{
          state: {
            refresh:true,
            activeTab:"completed",
          },
       });
      }
    }
    catch (err) {
      console.log('err', err);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }

  }


  return (
    <div>
      <Header />
      <div className="container-fluid main-container">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          {/* LEFT TITLE */}
          {/* Header */}
          <div onClick={() => navigation(-1)} className="admin-header mb-0">
            <img src={leftArrow} className="back-icon-arrow" />
            <h2>Transaction Management</h2>
          </div>
          {/* <h3 className="m-0 fw-bold fs-5 text-black">Transaction Management</h3> */}

          {/* RIGHT SECTION */}
          <div className="d-flex align-items-center gap-3">
            {/* SEARCH BOX */}
            {/* <div className="search-box d-flex align-items-center px-3">
                            <input
                                type="text"
                                placeholder="Search"
                                className="border-0 outline-none bg-transparent"
                            />
                            <div className="ms-2 searchdote" >|</div>
                            <FaSearch color='#7A52AB' className="ms-1" />
                        </div> */}

            {/* ADD BUTTON */}
            {status === "pending" && (
              <button
                onClick={() => setPopup(true)}
                style={{ backgroundColor: "#259AF9" }}
                className="btn text-white fw-semibold px-4 py-2"
              >
                Pay Now
              </button>
            )}
          </div>
        </div>
        <MaterialTable
          columns={columns}
          data={adminList || []}
          enableRowSelection={status === "pending"}
          getRowId={(row) => row.id}
          onRowSelectionChange={handleSelectionChange}
        // enableRowSelection={location?.state==="pending"}
        />
      </div>

      {/* Logout Confirmation Popup */}
      {popup && (
        <div className="img-popup-design "
        onClick={()=>setPopup(false)}>
          <div className="img-popup bg-white border-0  text-center "
          onClick={(e) => e.stopPropagation()}
          >
            <h4
              className="mb-2"
              style={{ color: "#F98425" }}>
              Transaction Name
            </h4>
            {/* <div className="border d-flex pt-3 pb-5 align-items-start border-rounded rounded-2 mt-4  ps-2 ">
              <p className="f3 text-black"></p>
            </div> */}
            {/* <div className="d-flex ac-jc mt-3"> */}
            <input type="text"
              className="ps-3 w-90 mb-3 py-4 border rounded rounded-1"
              value={valuee}
              onChange={(e) => setValuee(e.target.value)} />
            {/* <textarea type="text"
              className="px-5 py-4 w-90 my-3 border rounded rounded-1"
              value={valuee}
              onChange={(e) => setValuee(e.target.value)} /> */}
            {/* </div> */}
            {/* <div className="d-flex ac-jc px-2 mt-3"> */}
            <button
              onClick={handleSubmit}
              className="submit-btn w-40"
              disabled={isLoading}
            >
              {/* Submit */}
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                "Submit"
              )}
            </button>
            {/* </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionView;
